export default __webpack_public_path__ + "static/media/planit_logo_light.88930122.svg";